export default __webpack_public_path__ + "svg/CompaniesLogos/logo_innova-export.svg?5656a6c8";